import styled from 'styled-components';
import { colors } from 'globalStyles';

export const Wrapper = styled.div`
  padding-top: 22px;
  width: 300px;
  text-align: center;

  > h1 {
    padding-top: 30px;
    color: ${colors.RED};
    font-size: 32px;
    line-height: 44px;
    margin: 0;
  }
`;

export const PasswordNeeds = styled.div`
  font-size: 16px;
  color: ${colors.BODY};
  margin: 10px 0 0;
`;

export const PasswordNeedWrapper = styled.div`
  > svg {
    margin-right: 10px;
    ${({ hasError }) =>
      `fill: ${
        hasError
          ? colors.RED
          : colors.GREEN
      };`
    }
  }
`;



// WEBPACK FOOTER //
// ./src/components/InvalidPasswordModal/styledComponents.js